import React from "react";
import { classNames } from "../../../../general/functions/propsComponent";
import {
  CameraVideoFill,
  CameraVideoOffFill,
  MicFill,
  MicMuteFill,
  TelephoneFill,
} from "react-bootstrap-icons";
import TimmerPduli from "./TimmerPduli";
import { utcToClientDatetime } from "../../function/dateTimeCustomeFunction";
import useSessionDataPduli from "../../costumeHooks/useSessionDataPduli";
import ModalAkhiriSesi from "./ModalAkhiriSesi";
export default function KonselorControl(props) {
  const {
    setJoin,
    setShareScreen,
    setMute,
    tracksState,
    errorInfo,
    handleDurationComplete,
  } = props;
  const { dataSessionPduli } = useSessionDataPduli({});
  let momentClient = utcToClientDatetime(
    dataSessionPduli?.session?.date,
    dataSessionPduli?.session?.startTime
  ).add({
    minutes: dataSessionPduli?.session?.duration,
  });
  const mute = async (type) => {
    if (type === "audio") {
      setMute({ type: "audio", status: !tracksState.audio });
    } else if (type === "video") {
      setMute({ type: "video", status: !tracksState.video });
    }
  };
  const leaveChannel = async () => {
    setJoin(false);
  };

  console.log(
    "VideoKonselingSession time",
    momentClient.format("YYYY-MM-DD HH:mm:ss")
  );
  return (
    <div className="grid grid-cols-3 w-[95%] mx-auto">
      <div className="flex gap-2 ">
        <button
          className={classNames(
            tracksState.audio ? "on" : "",
            "btn-default02 p-2 w-12 h-12 flex flex-col justify-center items-center rounded-full"
          )}
          onClick={() => mute("audio")}
        >
          {tracksState?.audio ? (
            <MicFill size={16} />
          ) : (
            <MicMuteFill size={16} className="text-red-500" />
          )}{" "}
        </button>
        <button
          className={classNames(
            tracksState.video ? "on" : "",
            "btn-default02 p-2 w-12 h-12 rounded-full flex flex-col justify-center items-center"
          )}
          onClick={() => mute("video")}
        >
          {tracksState?.video ? (
            <CameraVideoFill size={16} />
          ) : (
            <CameraVideoOffFill size={16} className="text-red-500" />
          )}{" "}
        </button>
      </div>
      <div className="flex gap-2 flex-col items-center">
        <p className="text-white text-sm leading-3">Duration</p>
        <p className="text-white text-2xl leading-3">
          <TimmerPduli
            endTime={momentClient.format("YYYY-MM-DD HH:mm:ss")}
            setComplete={(v) => {
              if (v) {
                handleDurationComplete();
              }
            }}
            mode="SIMPLE"
          />
        </p>
        <p className="text-white text-2xl  leading-4"></p>
      </div>
      <div className="flex gap-2 justify-end relative">
        {/* <button
          className={classNames(
            "btn-primary bg-red-500 p-2 w-14 h-14 flex flex-col justify-center items-center whitespace-nowrap rounded-full absolute -top-1"
          )}
          onClick={() => leaveChannel()}
        >
          <p className="text-sm font-semibold">
            <TelephoneFill size={24} className="rotate-[135deg] " />{" "}
          </p>
        </button> */}
        <ModalAkhiriSesi
          handleChoosen={(v) => {
            if (v == "LEAVE") {
              leaveChannel();
            }
          }}
        />
      </div>
    </div>
  );
}
